import React from 'react';
import { motion } from 'framer-motion';
import type { StylistCardProps } from './types';

const StylistCardSmall: React.FC<StylistCardProps> = ({ stylist, onSelect, buttonText = 'Select' }) => {
  const isSelected = buttonText === 'Selected';
  
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      onClick={() => onSelect(stylist)}
      className={`rounded-lg overflow-hidden hover:shadow-md transition-all relative h-64 cursor-pointer ${
        isSelected 
          ? 'opacity-100 shadow-lg brightness-110' 
          : 'opacity-50 hover:opacity-70'
      }`}
    >
      {/* Full card background image */}
      <img 
        src={stylist.image} 
        alt={stylist.name}
        className="absolute inset-0 w-full h-full object-cover"
      />
      
      {/* Gradient overlay only at bottom for content */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent"></div>
      
      {/* Content overlay */}
      <div className="relative h-full flex flex-col">
        {/* Content area with light black background */}
        <div className="flex-1 flex flex-col justify-end">
          <div className="bg-black/30 p-2 pb-12">
            <h3 className="text-sm font-bold text-white mb-0.5 line-clamp-1">
              {stylist.name}
            </h3>
            <p className="text-white text-xs font-semibold">
              {stylist.role}
            </p>
          </div>
        </div>
        
        {/* Button fixed at bottom */}
        <div className="absolute bottom-0 left-0 right-0">
          <button
            onClick={() => onSelect(stylist)}
            className={`w-full py-2 text-xs text-white hover:bg-primary/90 transition-colors font-semibold ${
              buttonText === 'Selected' 
                ? 'bg-green-600 hover:bg-green-700' 
                : 'bg-primary'
            }`}
          >
            {buttonText === 'Selected' && (
              <span className="material-symbols-outlined text-xs inline-block mr-1">check_circle</span>
            )}
            {buttonText}
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default StylistCardSmall;
